import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 8px;
  border-radius: 5px;

  &:hover {
    background-color: ${ ({ theme }) => theme.colors.almostWhite };
  }

  .checkbox-container {
    background-color: ${ ({ theme }) => theme.colors.white };
    border-radius: 5px;
    &.selected {
      background-color: ${ ({ theme }) => theme.colors.primary };
    }
  }

  .tag-container {
    width: 32px;
    height: 32px;
    padding: 5px;
    border-radius: 6px;
    justify-content: center;

    .tag-text {
      font-size: 14;
      text-align: center;
    }
  }
`
